import { driver } from "driver.js";
import "driver.js/dist/driver.css";

const wait = (ms) => new Promise((r) => setTimeout(r, ms));

async function waitFor(selector, ms = 8000) {
  for (let t = 0; t < ms && !document.querySelector(selector); t += 250) await wait(250);
}

async function prepare(step) {
  for (const a of step.prepare || []) {
    await waitFor(a.unless ? `${a.click}, ${a.unless}` : a.click);
    if (a.unless && document.querySelector(a.unless)) continue;
    document.querySelector(a.click)?.click();
    await wait(800);
  }
  if (step.element) await waitFor(step.element);
}

// Visite guidée : met en surbrillance les éléments un par un avec une bulle d'explication
export async function runTour(steps) {
  if (!steps?.length) return;
  await prepare(steps[0]);
  const tour = driver({
    showProgress: true,
    progressText: "{{current}} / {{total}}",
    nextBtnText: "Suivant →",
    prevBtnText: "← Précédent",
    doneBtnText: "Terminer",
    popoverClass: "guide-tour-popover",
    steps: steps.map((s) => ({ element: s.element, popover: { title: s.title, description: s.text } })),
    onNextClick: async () => {
      const next = steps[tour.getActiveIndex() + 1];
      if (next) await prepare(next);
      tour.moveNext();
    },
  });
  tour.drive();
}

// Empêche une fenêtre (Dialog) de se fermer quand on clique la bulle de la visite
export const keepOpenDuringTour = (e) => {
  if (e.target?.closest?.(".driver-popover, .driver-overlay")) e.preventDefault();
};
